import type { SelectedOption, SharedSelectProps } from "./SelectBase";
import { isMissingSelectedOption, SelectBase } from "./SelectBase";
import { SelectOption } from "./SelectOption";
export interface SelectProps<T> extends SharedSelectProps<T> {
    /**
     * The current value of the select
     */
    value: string | undefined;
    /**
     * The action to perform when the form control field is changed.
     */
    onChange: (newValue: string | undefined) => void;
}
export function Select<T>(props: SelectProps<T>) {
    const handleOptionsSelected = (options: SelectedOption[]) => {
        props.onChange(options[0].value);
    };
    const renderOption = (option: SelectOption, selected: boolean) => <SelectOption option={option} selected={selected}/>;
    const renderSelection = (selectedOptions: SelectedOption[]) => (isMissingSelectedOption(selectedOptions[0]) ? "" : selectedOptions[0].label);
    return (<SelectBase {...props} isMultiSelectable={false} renderOption={renderOption} onOptionsSelected={handleOptionsSelected} renderSelection={renderSelection} clearSelection={() => {
            props.onChange(undefined);
        }}/>);
}
